import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
  paper: {
    padding: '1%',
  },
  container: {
    marginBottom: '40% !important',
    padding: '1%',
  },
}));
